import {RichTextEditor, MenuButtonBold, MenuButtonItalic, MenuControlsContainer, MenuDivider, MenuSelectHeading} from "mui-tiptap";
import StarterKit from "@tiptap/starter-kit";
import {useTranslation} from "react-i18next";
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import React, {useRef} from 'react';
import {observer} from 'mobx-react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_DESC} from './TaxCommon.js';
import {COMM_OK} from '../WsR2.js';

const TaxDesc = observer(() => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const ref = useRef(null);

	function descRxWs(status, msg) {
		if (status !== COMM_OK || msg.result !== 'OK') {
			console.error('descRxWs: error ', status, msg);
			return -1;
		}

		if (msg.cmd === 'tax' && msg.op === 'desc') {
 			// console.log('descRxWs, desc', msg.data);

			let j = msg.data.taxon.desc && msg.data.taxon.desc.length  ? JSON.parse(msg.data.taxon.desc) : msg.data.taxon.desc;

			if (j.type !== 'doc')
				j = msg.data.taxon.desc;

			gStorage.taxons.setDesc(j);
		} else if (msg.cmd === 'tax' && msg.op === 'desc_save') {
			gStorage.taxons.setDescChanged(false);
		} else {
			console.error('descRxWs: unknown command', msg.cmd, msg.op, msg.result);
		}
	}

	function loadDesc(tax) {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'tax',
			op: 'desc',
			data: {
				taxon: {
					id: tax.id,
				}
			}
		};

// 		console.log('loadDesc', msg);
		gStorage.conn.ws.send(msg, descRxWs);
	};

	function saveDesc(data) {
// 		console.log('saveDesc', data);
// 		gStorage.taxons.setDesc(data);

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'tax',
			op: 'desc_save',
			data: {
				taxon: {
					id: tax.id,
					desc: data
				}
			}
		};

		gStorage.conn.ws.send(msg, descRxWs);
	}

	function saveTaxonDesc() {
		saveDesc(JSON.stringify(ref.current.editor.getJSON()));
	}

	function onDescChange(editorState) {
 		// console.log('descChange', editorState);
		gStorage.taxons.setDescChanged(true);
	}

	if (gStorage.taxons.tab !== TAB_DESC)
		return null;
	
	let tax = gStorage.taxons.centerTaxon;
	if (!tax) 
		return null;

	if (gStorage.taxons.desc === null && gStorage.conn.online) {
		loadDesc(tax);
		return null;
	}

	return (<div /*style={{width:300}}*/>
			<Grid size={{xs: 12}} align={'left'}>
				{gStorage.conn.user.id === 1 ?
					<RichTextEditor sx={{mt:2}}
						ref={ref}
						extensions={[StarterKit]}
						content={gStorage.taxons.desc}
						onUpdate={onDescChange}
						renderControls={() => (
							<MenuControlsContainer>
								<MenuSelectHeading />
								<MenuDivider />
								<MenuButtonBold />
								<MenuButtonItalic />
							</MenuControlsContainer>
						)}
					/>
					:
					gStorage.taxons.desc &&
					<RichTextEditor sx={{mt:2}}
						extensions={[StarterKit]}
						content={gStorage.taxons.desc}
						editable={false}
					/>
				}
			</Grid>
			<Grid size={{xs: 12}} align={'center'}>
				<div>
					{gStorage.conn.user.id === 1 && 
						<Button 
							variant="contained" 
							color="primary" 
							size="small" 
							style={{width:143, margin: 4}} 
							disabled={gStorage.conn.user.id !== 1 || !gStorage.taxons.descChanged || !gStorage.conn.online}
							onClick={saveTaxonDesc}>
							{t('add.save')}
						</Button>
					}
				</div>
			</Grid>
		</div>);
});

export default TaxDesc;
